/**
 * 封装fetch
 * 提供方法 api、api.get、api.post
 * 跨域请求请查看文档 https://github.github.io/fetch/#options
 */
import API from './IAPI';
import router from '@/router';
type CallBackFn = (res: Response) => Promise<Response>;
const _checkStatus = (response: Response) => {
  if (response.status >= 200 && response.status < 300) {
    return response;
  } else if (response.status === 403 || response.status === 404) {
    router.replace(`/error/${response.status}`);
  } else {
    const error = new Error(response.statusText) as Error&{response: Response};
    error.response = response;
    throw error;
  }
};

/**
 * 私有函数，包装fetch返回值
 * @param url 请求接口
 * @param method 请求方法
 * @param params 请求参数
 * @param cb 请求回调
 */
const _fetchResult = <URL extends keyof API>(url: URL, method: string, params?: RequestInit, cb?: CallBackFn) => {
  return fetch(url, {
    method,
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(params),
    mode: 'same-origin',
    credentials: 'same-origin', // cross-site cookie must set to be 'include'
    ...params,
  }).then(_checkStatus).then((res:any) => {
    if (cb && typeof cb === 'function') {
      return cb(res);
    }
    return res.json();
  });
};

/**
 * 默认api方法
 * @param url
 * @param params
 * @param cb
 */
const api = <URL extends keyof API>(
  url: URL,
  params?: RequestInit,
  cb?: (res: Response) => Promise<Response>
): Promise<API[URL]> => {
  return _fetchResult(url, 'GET', params, cb);
};
type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
type RequestInitGet = Omit<RequestInit, 'method'>;
type RequestInitPost = Omit<RequestInit, 'method'>;
// 默认get，不支持method修改
api.get = <URL extends keyof API>(
  url: URL,
  params?: RequestInitGet,
  cb?: (res: Response) => Promise<Response>
): Promise<API[URL]> => {
  return _fetchResult(url, 'GET', params, cb);
};
// 默认post，不支持method修改
api.post = <URL extends keyof API>(
  url: URL,
  params?: RequestInitPost,
  cb?: (res: Response) => Promise<Response>
): Promise<API[URL]> => {
  return _fetchResult(url, 'POST', params, cb);
};

export { api as fetchApi, Omit };